import URL from '../url'
import Request from '../request'

export const scormCreateUploadUrlService = data =>
  new Request(URL.API, URL.SCORM_CREATE_UPLOAD_URL).post(data)

// Replace existing package — reuses same id, returns { id, key, uploadUrl, expiresAt }
export const scormReplaceService = (id, data) =>
  new Request(URL.API, `${URL.SCORM_REPLACE}/${id}`).post(data)

export const scormCreateMultipartUploadService = data =>
  new Request(URL.API, URL.SCORM_CREATE_MULTIPART_UPLOAD).post(data)

export const scormSignUploadPartService = data =>
  new Request(URL.API, URL.SCORM_SIGN_UPLOAD_PART).post(data)

export const scormCompleteUploadService = data =>
  new Request(URL.API, URL.SCORM_COMPLETE_UPLOAD).post(data)

export const scormGetByIdService = (id, blockId) =>
  new Request(URL.API, URL.SCORM_GET_BY_ID).get(
    blockId ? { id, blockId } : { id },
  )

// Public/anonymous endpoint — no JWT required.
// Returns { entryPointUrl: full URL, status }.
export const scormGetEntryPointUrlService = id =>
  new Request(URL.API, `${URL.SCORM_ENTRY_POINT_URL}/${id}`).get()

// Paginated list of user's own SCORM packages (filtered by shop ownership).
// Body: { currentPage, pageSize, filterText? }
// Returns PaginatedList<ScormPackageDto> with entryPointUrl as full URL.
export const scormFilterService = data =>
  new Request(URL.API, URL.SCORM_FILTER).post(data)

// excludeCardId: the page the block was removed from, so the backend's in-use check skips its
// not-yet-saved edit. The backend refuses while any other page still uses the package.
export const scormDeleteService = (id, excludeCardId) =>
  new Request(
    URL.API,
    `${URL.SCORM_DELETE}/${id}${
      excludeCardId ? `?excludeCardId=${excludeCardId}` : ''
    }`,
  ).delete()

export const scormTrackService = data =>
  new Request(URL.API, URL.SCORM_TRACK).post(data)

export const scormGetResultService = (scormPackageId, courseId, learnerId) =>
  new Request(URL.API, URL.SCORM_GET_RESULT).get({ scormPackageId, courseId, learnerId })
